import { workSheetConstants } from '../../_constants/workSheet.constants';
import { workSheetService } from '../../_services/workSheet/workSheet.service';

export const worksheetAction = {
    createWorksheet,
    orientationApi,
    getWorksheetHandler,
    saveWorksheetHandler,
    shareWorksheetHandler,
    removeSharingWorksheetHandler,
    updateWorksheetHandler,
    getSharedUsersHandler,
    saveCommentHandler,
    getCommentListHandler,
    getWorkSheetDetailsHandler,
    getSharedWithUsersHandler,
    getWeakAreaHandler,
};


function createWorksheet(data) {
    return dispatch => {
        dispatch(request());
        workSheetService.createApiService(data)
            .then(
                createWorksheet => {
                    dispatch(success({ createWorksheet }));
                    dispatch(getWorksheetHandler(data.assessment))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };
    function request() { return { type: workSheetConstants.REQUEST_CREATE_WORKSHEET } }
    function success(createWorksheet) { return { type: workSheetConstants.RECEIVE_CREATE_WORKSHEET, createWorksheet } }
    function failure(error) { return { type: workSheetConstants.ERROR_CREATE_WORKSHEET, error } }
}

function orientationApi(data, assessmentId, callback) {
    return dispatch => {
        dispatch(request());
        workSheetService.orientationApiService(data)
            .then(
                orientation => {
                    dispatch(success({ orientation, id: assessmentId }));
                    if (callback) {
                        callback(orientation)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };
    function request() { return { type: workSheetConstants.REQUEST_ORIENTATION_WORKSHEET } }
    function success(orientation) { return { type: workSheetConstants.RECEIVE_ORIENTATION_WORKSHEET, orientation } }
    function failure(error) { return { type: workSheetConstants.ERROR_ORIENTATION_WORKSHEET, error } }
}

function getWorksheetHandler(data) {
    return dispatch => {
        dispatch(request());
        workSheetService.getWorksheetHandler(data)
            .then(
                getWorksheet => {
                    dispatch(success(getWorksheet));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };
    function request() { return { type: workSheetConstants.REQUEST_GET_WORKSHEET } }
    function success(getWorksheet) { return { type: workSheetConstants.RECEIVE_GET_WORKSHEET, getWorksheet } }
    function failure(error) { return { type: workSheetConstants.GET_WORKSHEET_ERROR, error } }
}

function saveWorksheetHandler(id, data, callback) {
    return dispatch => {
        dispatch(request());
        workSheetService.saveWorksheetHandler(data)
            .then(
                saveWorksheet => {
                    dispatch(success(saveWorksheet));
                    dispatch(getWorkSheetDetailsHandler(id, (response) => { }))
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };
    function request() { return { type: workSheetConstants.REQUEST_SAVE_WORKSHEET } }
    function success(saveWorksheet) { return { type: workSheetConstants.RECEIVE_SAVE_WORKSHEET, saveWorksheet } }
    function failure(error) { return { type: workSheetConstants.SAVE_WORKSHEET_ERROR, error } }
}

function shareWorksheetHandler(data) {
    return dispatch => {
        dispatch(request());
        workSheetService.shareWorksheetHandler(data)
            .then(
                shareWorksheet => {
                    dispatch(success(shareWorksheet));
                    dispatch(getSharedWithUsersHandler(data.worksheet))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: workSheetConstants.REQUEST_SHARE_WORKSHEET } }
    function success(shareWorksheet) { return { type: workSheetConstants.RECEIVE_SHARE_WORKSHEET, shareWorksheet } }
    function failure(error) { return { type: workSheetConstants.SHARE_WORKSHEET_ERROR, error } }
}

function removeSharingWorksheetHandler(data) {
    return dispatch => {
        dispatch(request());
        workSheetService.removeSharingWorksheetHandler(data.data)
            .then(
                removeSharingWorksheet => {
                    dispatch(success(removeSharingWorksheet));
                    dispatch(getSharedWithUsersHandler(data.workSheetId));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: workSheetConstants.REQUEST_REMOVE_SHARING_WORKSHEET } }
    function success(removeSharingWorksheet) { return { type: workSheetConstants.RECEIVE_REMOVE_SHARING_WORKSHEET, removeSharingWorksheet } }
    function failure(error) { return { type: workSheetConstants.REMOVE_SHARING_WORKSHEET_ERROR, error } }
}

function updateWorksheetHandler(data) {
    return dispatch => {
        dispatch(request());
        workSheetService.updateWorksheetHandler(data)
            .then(
                updateWorksheet => {
                    dispatch(success(updateWorksheet));
                    dispatch(getWorksheetHandler(data.assessmentId));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: workSheetConstants.REQUEST_UPDATE_WORKSHEET } }
    function success(updateWorksheet) { return { type: workSheetConstants.RECEIVE_UPDATE_WORKSHEET, updateWorksheet } }
    function failure(error) { return { type: workSheetConstants.UPDATE_WORKSHEET_ERROR, error } }
}

function getSharedUsersHandler(callback) {
    return dispatch => {
        dispatch(request());
        workSheetService.getSharedUsersHandler()
            .then(
                getSharedUsers => {
                    dispatch(success(getSharedUsers));
                    if (callback) {
                        callback(getSharedUsers)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: workSheetConstants.REQUEST_GET_SHARED_USERS } }
    function success(getSharedUsers) { return { type: workSheetConstants.RECEIVE_GET_SHARED_USERS, getSharedUsers } }
    function failure(error) { return { type: workSheetConstants.GET_SHARED_USERS_ERROR, error } }
}

function saveCommentHandler(commentData) {
    return dispatch => {
        dispatch(request());
        workSheetService.saveCommentHandler(commentData)
            .then(
                saveComment => {
                    dispatch(success(saveComment));
                    dispatch(getCommentListHandler(commentData.worksheet))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: workSheetConstants.REQUEST_SAVE_COMMENT } }
    function success(saveComment) { return { type: workSheetConstants.RECEIVE_SAVE_COMMENT, saveComment } }
    function failure(error) { return { type: workSheetConstants.SAVE_COMMENT_ERROR, error } }
}

function getCommentListHandler(id) {
    return dispatch => {
        dispatch(request());
        workSheetService.getCommentListHandler(id)
            .then(
                getCommentList => {
                    dispatch(success(getCommentList));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: workSheetConstants.REQUEST_GET_COMMENT_LIST } }
    function success(getCommentList) { return { type: workSheetConstants.RECEIVE_GET_COMMENT_LIST, getCommentList } }
    function failure(error) { return { type: workSheetConstants.GET_COMMENT_LIST_ERROR, error } }
}

function getWorkSheetDetailsHandler(data, callback) {
    return dispatch => {
        dispatch(request());
        workSheetService.getWorkSheetDetailsHandler(data)
            .then(
                getWorkSheetDetails => {
                    dispatch(success(getWorkSheetDetails));
                    callback(getWorkSheetDetails)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: workSheetConstants.REQUEST_GET_WORKSHEET_DETAILS } }
    function success(getWorkSheetDetails) { return { type: workSheetConstants.RECEIVE_GET_WORKSHEET_DETAILS, getWorkSheetDetails } }
    function failure(error) { return { type: workSheetConstants.GET_WORKSHEET_DETAILS_ERROR, error } }
}

function getSharedWithUsersHandler(id) {
    return dispatch => {

        dispatch(request());
        workSheetService.getSharedWithUsersHandler(id)
            .then(
                getSharedWithUsers => {
                    dispatch(success(getSharedWithUsers));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: workSheetConstants.REQUEST_GET_SHARED_WITH_USERS } }
    function success(getSharedWithUsers) { return { type: workSheetConstants.RECEIVE_GET_SHARED_WITH_USERS, getSharedWithUsers } }
    function failure(error) { return { type: workSheetConstants.GET_SHARED_WITH_USERS_ERROR, error } }
}

function getWeakAreaHandler(data) {
    return dispatch => {
        dispatch(request());
        workSheetService.getWeakAreaHandler(data)
            .then(
                getWeakArea => {
                    dispatch(success(getWeakArea));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: workSheetConstants.REQUEST_WEAK_AREA } }
    function success(getWeakArea) { return { type: workSheetConstants.RECEIVE_WEAK_AREA, getWeakArea } }
    function failure(error) { return { type: workSheetConstants.WEAK_AREA_ERROR, error } }
}





// WEBPACK FOOTER //
// ./src/_actions/WorkSheet/workSheet.action.js